import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { DEFAULT_LANGUAGE_CODES } from './i18n/languageMeta';
import { BUILD_ID } from './buildInfo';

const supportedLngs = DEFAULT_LANGUAGE_CODES;
const localeCacheBuster = BUILD_ID ? `?v=${encodeURIComponent(String(BUILD_ID))}` : '';
const isCustomerAppRoute =
  typeof window !== 'undefined' && /^\/customer-app(?:\/|$)/.test(window.location.pathname);
const localeBasePath = isCustomerAppRoute ? '/customer-app/locales' : '/locales';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs,
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    cleanCode: true,
    debug: false,
    detection: {
      order: ['querystring', 'localStorage', 'cookie', 'navigator'],
      caches: ['localStorage', 'cookie'],
    },
    backend: {
      // Public customer app is served from /customer-app/, while the main dispatch app uses /.
      loadPath: `${localeBasePath}/{{lng}}.json${localeCacheBuster}`,
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default i18n;
